import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useContext } from 'react';
import { ExtraWalletContext } from '../context';
export default function PluginEntry({ icon, name, onClick }) {
    const { portkey: portkeyOpts } = useContext(ExtraWalletContext);
    return (_jsxs("div", { className: `plugin-entry plugin-entry-${portkeyOpts.design}`, onClick: onClick, children: [_jsx("div", { className: `icon ${icon}` }), _jsx("div", { className: "name", children: name })] }));
}
